module.exports = __webpack_public_path__ + "static/media/download.89536174.svg";